<template>
  <div class="wrapper">
    <section class="page_not_found">
      <div class="page_not_found__content">
        <h2 class="page_not_found__title title">404</h2>
        <h2 class="page_not_found__title description">{{ $t('message.pageNotFound') }}</h2>
      </div>
    </section>
  </div>
</template>
<script>
//import service from 'vuex-service-api'
export default {
  created() {}
};
</script>
<style lang="scss">
@import './src/scss/media-queries';
$c-green: #01d277;
$c-dark: #081c24;
$c-footer: #575757;
$c-white: #ffffff;
$c-light: #f8f8f8;
$c-preview: #f9f8f8;
$color-1: #383838; // Mine Shaft
$color-2: #7b9d6f; // Highland
$color-3: #ffffff; // White
$color-4: #f8f8f8; // Alabaster
// fonts
$primary-font: 'Fira Sans', sans-serif;
$secondary-font: 'Playfair Display', serif;
.page_not_found {
  width: 100%;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(81vh - 100px);
  @include tablet-min {
    height: calc(100vh - 75px);
  }
  &:before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba($c-light, 0.7);
  }
  &__content {
    width: 100%;
    padding: 0 20px;
    text-align: center;
    @include tablet-min {
      padding: 0 40px 40px 0;
    }
  }
  &__title {
    font-size: 24px;
    font-weight: 500;
    color: $c-dark;
    position: relative;
    margin: 0;
    @include tablet-min {
      font-size: 100px;
    }
  }
  &__button {
    position: relative;
    margin-top: 20px;
  }
}
img.search_not_found {
  margin: auto;
}
h2.page_not_found__title.title {
  color: #3e3e3e;
  font-weight: bold;
}
h2.page_not_found__title.description {
  color: #7c7c7c;
  font-size: inherit;
}
</style>



// WEBPACK FOOTER //
// 404.vue?7bde3129